<template>
  <div>
    <ul v-if="scrapbooks">
      <li v-for="scrapbook in scrapbooks" :key="scrapbook.id">
        <router-link :to="{ name: 'scrapbook', params: { id: scrapbook.id }}"><a>{{ scrapbook.name }}</a></router-link> <span><button @click.prevent="del(scrapbook.id)" class="nobutton">Delete</button></span>
      </li>
    </ul>
    <div v-if="!scrapbooks">
      No scrapbooks available
    </div>
  </div>
</template>

<script>
import DataScrapbooks from "@/js/data/controllers/DataScrapbooks.js";

import store from '@/store'

export default {
  name: 'scrapbook-list',
  computed: {
    scrapbooks () {
      return store.state.user.scrapbooks
    }
  },
  async mounted () {
    // DataScrapbooks.getList()
  },
  methods: {
    async del (item) {
      let conf = confirm('Are you sure you want to delete this item? This cannot be undone')
      if (conf) {
        DataScrapbooks.deleteScrapbook(item)
      }
      return
    }
  }

}
</script>
